export default __webpack_public_path__ + "static/media/ghostbusters.e8d3c41f.png";